import Repository from '@/repositories/marketing'
const crmsResource = '/crms'

export default {
	/**
	 * @use Product feeds drawer
	 */
	fetch(config) {
		return Repository.get(`${crmsResource}/types.json`, config)
	},
	getStore(config) {
		return Repository.get(`${crmsResource}/abandoned_trigger_eligible_stores.json`, config)
	},
	create(payload){
		return Repository.post(`${crmsResource}.json`, payload)
	},

	update(id, payload){
		return Repository.patch(`${crmsResource}/${id}.json`, payload)
	},

	delete(id){
		return Repository.delete(`${crmsResource}/${id}.json`)
	},

	archive(id){
		return Repository.put(`${crmsResource}/${id}/archived.json`)
	},
	storeFindifyStatus(id){
		return Repository.get(`${crmsResource}/${id}/fetch_findify_recommendation_status.json`)
	},
	getAbandonedTag(id){
		return Repository.get(`${crmsResource}/${id}/get_abandoned_tag.json`)
	}
}
